import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useEffect, useState } from "react";
import devices from "../../../devices.json";

export default function AddDevice(props) {
  const [open, setOpen] = useState(false);
  const [uuid, setUuid] = useState("");
  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const isUuid = (uuid) => {
    let s = null;
    s = devices.find((item) => item.shortId === uuid);
    if (s !== undefined) {
      return true;
    } else {
      s = uuid.match(
        "^[0-9a-fA-F]{8}[0-9a-fA-F]{4}[0-9a-fA-F]{4}[0-9a-fA-F]{4}[0-9a-fA-F]{12}$"
      );
      return s !== null;
    }
  };

  const handleClose = () => {
    setOpen(false);
    const fullId =
      uuid.length === 8
        ? devices.find((item) => item.shortId === uuid)?.uuid
        : uuid;
    if (props.callback) props.callback(isUuid(fullId) ? fullId : null);
    setUuid("");
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Add a channel</DialogTitle>
        <DialogContent>
          <DialogContentText>Please enter your device UUID:</DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="uuid"
            label="Device UUID"
            type="text"
            fullWidth
            variant="standard"
            value={uuid}
            onChange={(e) => {
              setUuid(e.target.value);
            }}
            error={!!uuid && !isUuid(uuid)}
            helperText={
              uuid.length === 0 || isUuid(uuid) ? "" : "the UUID is not valid!"
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose}>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
